<template>
  <div class="lp-toolbar-textarea-color-container">
    <preset-input-color
      :value="editor.getAttributes('textStyle').color"
      @input="handleSelectColor"
      @menuOpened="handleMenuState"
      class="lp-toolbar-textarea-color"
      :small="true"
      :closeButton="closeButton">
    </preset-input-color>
  </div>
</template>

<script>
import PresetInputColor from "../../components/slides/styles/PresetInputColor.vue"

export default {
  props: ["editor", "closeButton"],
  components: { PresetInputColor },
  data() {
    return {
      isMenuOpened: false
    }
  },
  methods: {
    handleSelectColor(color) {
      if (this.isMenuOpened) this.editor.chain().setColor(color).run()
    },
    handleMenuState(isOpen) {
      this.isMenuOpened = isOpen

      if (!this.isMenuOpened) {
        this.editor.chain().focus().run();
      }
    }
  }
}
</script>

<style>
.lp-toolbar-textarea-color-container {
  display: flex;
  margin-left: 10px;
}
.lp-toolbar-textarea-color {
  margin-right: 10px;
}
</style>
